import React from 'react';

const Cancellation = {
  title: 'Change and Cancellation policy',
  subTitle: [
    {
      title: 'Trip',
      items: [
        {
          header: 'Change and Cancellation Policy for Bookings',
          content: (
            <div>
              <p><b>Making changes to purchased trips</b></p>
              <ul>
                <li><p>Notice has to be given to <a href="mailto:support@takemetour.com">support@takemetour.com</a></p></li>
                <li><p>Change of trip after purchase can be made only with your Local Expert’s agreement. It is also subject to availability.</p></li>
                <li><p>Change of trip and/or Local Expert after purchase can be arranged only if you agree that you will be responsible for cost differences. TakeMeTour reserves the right to withhold any excessive amount.</p></li>
                <li><p>If the Local Expert cannot reschedule or is not available for the trip, the trip will consider to be cancelled. The cancellation policy below will apply based on the submission date of your trip change request.</p></li>
              </ul>
              <p><b>Cancellation of purchased trips</b></p>
              <p>Notice has to be given to <a href="mailto:support@takemetour.com">support@takemetour.com</a></p>
              <ul>
                <li><p>A booking using promo code or with add-on item(s) will be considered non-refundable under any circumstances.</p></li>
                <li><p>If you do not show up on the trip day, the trip will be considered canceled and non-refundable.</p></li>
                <li><p>If you make a request to cancel the trip at least 7 days in advance of the trip day, prior to 12:00 AM (Local time GMT+7). If the request is successful, a full refund excluding booking fee will be transferred to you based on your payment method. It might take up to 15 business days to reflect on your bank account.</p></li>
                <li><p>If you make a request less than 7 days in advance of the trip day, prior to 12:00 AM (Local time GMT+7). The trip will be considered canceled and non-refundable.</p></li>
                <li><p>If you purchase our Worry - Free booking, you will be able to cancel the trip before 06:00 PM on the day before the trip date, and get a full refund including booking fee. (Excluding 149 THB for Worry - free booking).</p></li>
                {/* <li>
                  <p>In the event of trip cancellation, a refund request has to be made at least 7 days in advance of the trip day, prior to 12:00 AM (Local time GMT+7).</p>
                  <p>If the request is successful, a full refund excluding booking fee will be transferred to you based on your payment method. It might take up to 15 business days to reflect on your bank account.</p>
                </li> */}
                {/* <li><p>If you make a request less than 7 days in advance of the trip day, prior to 12:00 AM (Local time GMT+7). The trip will be considered canceled and non-refundable.</p></li> */}
                <li><p>Under special circumstances and bad weather, we may consider the refund on a case by case basis. Please submit solid reasons and evidence to our support team at <a href="mailto:support@takemetour.com">support@takemetour.com</a></p></li>
              </ul>
              <p><b>Refund Request Period</b></p>
              <ul>
                <li><p>Any refund request under unsatisfaction must be made no later than 2 days after the trip day</p></li>
                <li><p>The request will be canceled if you release a payment to your Local Expert.</p></li>
              </ul>
            </div>
          )
        },
        {
          header: 'What should I do if I need to cancel my trip due to an emergency or unavoidable circumstance?',
          content: (
            <div>
              <p>Under our Extenuating Circumstances policy, TakeMeTour may waive the traveler cancellation penalties stated in TakeMeTour Change and Cancellation Policy for bookings.</p>
              Reasons considered extenuating circumstances include:
              <ul>
                <li><p>Unexpected death, fatal injury, or serious illness of a traveler or immediate family member (spouse/partner, child, parent, legal guardian, grandparent or sibling)</p></li>
                <li><p>Serious injury that directly restricts a traveler’s ability to travel</p></li>
                <li><p>Significant natural disasters or severe weather incidents impacting the location of destination or attraction in the itinerary.</p></li>
                <li><p>Urgent travel restrictions or severe security advisories issued after the time of booking, by an appropriate national or international authority (such a government office or department)</p></li>
                <li><p>Endemic disease declared by a credible nation or international authority (such as the US Centers for Disease Control or the World Health Organization)</p></li>
                <li><p>Government-mandated obligations issued after the time of booking (e.g. jury duty, court appearances, military or government assignments)</p></li>
              </ul>
              <p>If you would like to make a claim for your canceled trip due to extenuating circumstances, please contact <a href="mailto:support@takemetour.com">support@takemetour.com</a> as soon as possible. Supporting documents and proofs may be required.</p>
            </div>
          )
        },
        {
          header: 'How do I cancel the trip?',
          content: (
            <div>
              <p>Please carefully go through the change and cancellation policy for bookings before submitting the <a href="https://supporttmt.typeform.com/to/ha0wXR">cancellation form</a> to us. The notice must also be given to your Local Expert before the trip date as soon as possible.</p>
            </div>
          )
        },
        {
          header: 'How can I claim a refund?',
          content: (
            <div>
              <p>Any refund request must be made no later than 2 days after the trip day. It has to be submitted together with a solid reason for refund or other proofs to <a href="mailto:support@takemetour.com">support@takemetour.com</a></p>
            </div>
          )
        },
        {
          header: 'What is the policy for bad weather?',
          content: (
            <div>
              <p>As Thailand is one of the tropical countries, the climate is mostly dry and wet all year round. In case you find it unsafe to go on a trip due to bad weather upon arrival, we suggest you follow the steps below:</p>
              <ul>
                <li>
                  <p>Contact the Local Expert once your booking is confirmed and let them know your concern about the weather. You may ask for their suggestions as the Local Expert knows how to prepare for the trip. You may also discuss with them for options in case of bad weather on the trip date, such as rearrange the itinerary or change the trip date.</p>
                  <p>Please contact us once an agreement is made since you cannot reschedule a confirmed trip on your own.</p>
                </li>
                <li><p>Do not hesitate to contact us at <a href="mailto:support@takemetour.com">support@takemetour.com</a> if you cannot make an agreement with the Local Expert. We will do our best to help you.</p></li>
                <li><p>In case you cannot reschedule your trip and we cannot find a substitute Local Expert for you, your trip will be considered canceled. Please refer to the Change and Cancellation Policy for Bookings page below.</p></li>
              </ul>
            </div>
          )
        }
      ]
    },
    {
      title: 'Ticket',
      items: [
        {
          header: 'Change and Cancellation policy for tickets',
          content: (
            <div>
              <p>Purchased tickets/vouchers are non-refundable and the date of visit cannot be rescheduled.</p>
              <p>Under special circumstances, we may consider a refund in the form of voucher credits for any tour on TakeMeTour.com on a case by case basis. Please submit solid reason and evidence to our support team at <a href="mailto:support@takemetour.com">support@takemetour.com</a></p>
            </div>
          )
        },
        {
          header: 'Can I cancel the ticket?',
          content: (
            <div>
              <p>According to our change and cancellation policy for bookings, a ticket purchase cannot be canceled, refunded, or changed under any circumstances.</p>
            </div>
          )
        },
        {
          header: 'How do I change the date on my ticket?',
          content: (
            <div>
              <p>The date on your ticket could not be changed under any circumstances. Please check the ticket conditions in each ticket detail page.</p>
            </div>
          )
        }
      ]
    },
    {
      title: 'Transfer',
      items: [
        {
          header: 'Cancellation policy for the airport transfer or car/van rental service',
          content: (
            <div>
              <p>Confirmed airport transfer and car/van rental services are non-refundable under any circumstances.</p>
            </div>
          )
        },
        {
          header: 'Can I cancel the airport transfer or car/van rental service?',
          content: (
            <div>
              <p>According to our change and cancellation policy, the service cannot be canceled, refunded or changed under any circumstances.</p>
            </div>
          )
        },
        {
          header: 'How do I reschedule the airport transfer or car/van rental service?',
          content: (
            <div>
              <p>We would prefer you to recheck your booking details carefully before you complete your purchase since the service cannot be canceled, refunded, changed or rescheduled under any circumstances.</p>
            </div>
          )
        },
      ]
    },
    {
      title: 'Souvenir',
      items: [
        {
          header: 'Change and Cancellation policy for souvenirs/items',
          content: (
            <div>
              <p>We would prefer you to recheck your booking details carefully before you complete your purchase since the service cannot be canceled, refunded, changed or rescheduled under any circumstances.</p>
              <ul>
                <li><p>Purchased item(s)/ souvenir(s) are non-refundable</p></li>
                <li><p>If the delivery date needs to be changed, please notify us at <a href="mailto:support@takemetour.com">support@takemetour.com</a> at least 5 days in advance of the original delivery date.</p></li>
                <li><p>Under special circumstances, we may consider a refund in the form of voucher credits for any items purchase on TakeMeTour.com (booking fee is excluded) on a case by case basis. Please submit solid reason and evidence to our support team at <a href="mailto:support@takemetour.com">support@takemetour.com</a></p></li>
              </ul>
            </div>
          )
        },
        {
          header: 'Can I claim a refund?',
          content: (
            <div>
              <p>If your purchased souvenir(s) or item(s) is damaged or broken, please contact us at <a href="mailto:support@takemetour.com">support@takemetour.com</a> as soon as possible. We will do our best to help you. </p>
            </div>
          )
        }
      ]
    },
  ]
};

export default Cancellation;
